import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Parcel } from 'src/app/_models/parcel';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-propertySearch',
    templateUrl: './propertySearch.component.html',
    styleUrls: ['./propertySearch.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PropertySearchComponent implements OnInit {
  parcelItem: Parcel;
  parcelAddress = 'https://maps.assessor.lacounty.gov/GeoCortex/Essentials/PAIS/REST/sites/PAIS/VirtualDirectory/AssessorMaps/ViewMap.html?val=';

  constructor(public activatedRoute: ActivatedRoute) { }
  
  getAddress(event: Parcel) {
    if(event.AIN) {
      this.parcelItem = event
      console.log(event)
    }
  }

  calculate(val1: string, val2: string) {
    return Number(val1) + Number(val2)
  }
  calculateLand(val1: string, val2: string) {
    return Number(val1) * Number(val2)
  }

  ngOnInit() {
    this.activatedRoute.paramMap
      .pipe(map(() => window.history.state)).subscribe((item: Parcel) => {
        if(item.AIN) {
          this.parcelItem = item;
        }
        else {
          console.log('nothing')
        }
      })
  }
  

}
